import { FC, useEffect, useState } from "react";
import GridSelectorInput from "../../../../../components/controls/GridSelectorInput";
import GridWrapper from "../../../../../components/controls/GridWrapper";
import { CurrencyInput, NumberInput, TextAreaInput, TextInput } from "../../../../../components/controls/inputs";
import { BaseModalWindow } from "../../../../../components/modalWindows/BaseModalWindow";
import modalStyles from "../../../../../components/modalWindows/styles/BaseModalWindow.module.scss";
import { ScalingRatioSelectorModal } from "../../../../Dictionaries/ScalingRatio";
import styles from "../../styles/ActDisassemblingCreator.module.scss";
import { IEntitySimpleDTO } from "../../../../../libs/coreapi-dto/@types/common";
import { useForm } from "../../../../../system/hooks/useForm";
import { useTranslation } from "react-i18next";
import { ILotDTO } from "../../../../../libs/coreapi-dto/accounting/lot";
import { useAppContext } from "../../../../../system/providers/appContextProvider";
import { IPricingDocumentItemDTO } from "../../../../../libs/coreapi-dto/dirs/pricingInvoice";
import { ScalingRatioDataProvider } from "../../../../../Services/DataProviders/ScalingRatioDataProvider";
import { IActDisassemblingItemEditDTO } from "../../../../../libs/coreapi-dto/documents/actDisassemblingItem";
import { PricingDisassemblingDataProvider } from "../../../../../Services/DataProviders/PricingDisassemblingDataProvider";
import { GoodsDataProvider } from "../../../../../Services/DataProviders/GoodsDataProvider";
import { ICreateItem } from "../ActDisassemblingUpdateForm";
import { NumberInputWithSideEffect } from "../../../../../components/controls/inputs/BaseInput";
import { useLotRemain } from "../../../../../components/lotSelector/useLotRemain";
import { GetGnvlsPrice } from "./ActDisassemblingCreatorItemModal";
import { DateTime } from "luxon";
import { CreateFilterNumerator } from "../../../../../system/hooks/useGridFilter";
import { KizParsed } from "../../../../Dictionaries/Kiz/KizParsed";
import buffer from "buffer";
import { KizBoxEntity } from "../../../../Dictionaries/Kiz/KizBoxEntity";
import { KizDataProvider } from "../../../../../Services/DataProviders/KizDataProvider";
import { IKizBoxDTO, IKizDTO, IParsedBarcode } from "../../../../../libs/coreapi-dto/dirs/kiz";
import { v4 as uuidv4 } from "uuid";

interface IValidator {
    quantity: number;
    scalingRatioTo: IEntitySimpleDTO;
}

interface IActDisassemblingUpdateItemModal {
    idDocument: string;
    ok: (item: ICreateItem) => void;
    cancel: () => void;
    itemLot: ILotDTO;
    scanData?: string;
    kizCount: number;
    itemEdit: IActDisassemblingItemEditDTO;
    pricingModel: IEntitySimpleDTO;
}
interface IScalingRatioTo {
    scalingRatioEntityTo: IEntitySimpleDTO;
    scalingRatioToNumerator: number;
    scalingRatioToDenominator: number;
}

export const ActDisassemblingUpdateItemModal: FC<IActDisassemblingUpdateItemModal> = (props) => {
    const appCtx = useAppContext();
    const kizDataProvider = new KizDataProvider(appCtx.coreApiService);
    // Data providers
    const pricingDP = new PricingDisassemblingDataProvider(appCtx.coreApiService);
    const scalingRatioDP = new ScalingRatioDataProvider(appCtx.coreApiService);
    const goodsDP = new GoodsDataProvider(appCtx.coreApiService);

    const [item] = useState<ILotDTO>(props.itemLot);
    const [data, setData] = useState<IActDisassemblingItemEditDTO>(props.itemEdit);
    const [kizData, setKizData] = useState({ kizs: [] as IKizDTO[], kizOsuDtos: [] as IKizDTO[], kizBoxes: [] as IKizBoxDTO [] });

    const [scalingRatioTo, setScalingRatioTo] = useState<IScalingRatioTo>();

    const [isCalculated, setIsCalculated] = useState<boolean>(false);

    const [calculate, setCalculate] = useState<boolean>(false);

    const [isGnvls, setIsGnvls] = useState<boolean>(false);

    useEffect(() => {
    if (!props.scanData) return;
    let isActive = true;
    
    const scanDataBase64: string = buffer.Buffer.from(props.scanData, "ascii").toString("base64");
    const encodedBarcodeBase64 = encodeURIComponent(scanDataBase64);
    const kizParsed = new KizParsed(props.scanData);

    const parseBarcode = async () => {
        try {
            if (KizBoxEntity.isKizBox(props.scanData as string)) {
                const parsedBarcode = await new Promise<IParsedBarcode>(resolve => {
                    kizDataProvider.parse(encodedBarcodeBase64, resolve);
                });

                if (isActive && parsedBarcode.kizBoxData) {
                    setKizData(prev => ({
                        ...prev,
                        kizBoxes: [{
                            ...parsedBarcode.kizBoxData,
                            idGlobal: uuidv4(),
                            quantity: props.itemLot.numerator ?? 1
                        }]
                    }));
                }

            } else if (kizParsed.isKiz) {
                const parsedBarcode = await new Promise<IParsedBarcode>(resolve => {
                    kizDataProvider.parse(encodedBarcodeBase64, resolve);
                });
               
                if (isActive) {
                    const isPieceAccounting = props.itemLot.isPieceAccountingKizOsu;
                    if (parsedBarcode.kizData) {
                        setKizData(prev => {
                        const newKiz = { ...parsedBarcode.kizData, idGlobal: uuidv4() };
                        const currentKizs = prev.kizs || [];
                        const currentKizOsuDtos = prev.kizOsuDtos || [];
                        
                        return {
                            ...prev,
                            kizs: isPieceAccounting 
                                ? currentKizs 
                                : [...currentKizs, newKiz],
                            kizOsuDtos: isPieceAccounting 
                                ? [...currentKizOsuDtos, newKiz]
                                : currentKizOsuDtos
                            };
                        });
                    }

                    if (isPieceAccounting && parsedBarcode.kizOsuData) {

                        setKizData(prev => {
                        const newKiz: IKizDTO = {
                            idGlobal: uuidv4(),
                            barcode: parsedBarcode.kizOsuData.barcode,
                            decodedBarcode: parsedBarcode.kizOsuData.decodedBarcode,
                            rawBarcode: "",
                            gtinSGtin: parsedBarcode.kizOsuData.gtinSGtin,
                            sGtin: parsedBarcode.kizOsuData.sGtin,
                            gtin: parsedBarcode.kizOsuData.gtin,
                        };
                        const currentKizOsuDtos = prev.kizOsuDtos || [];
                        
                        return {
                            ...prev,
                            kizs: [],
                            kizOsuDtos: isPieceAccounting
                                ? [...currentKizOsuDtos, newKiz]
                                : currentKizOsuDtos
                            };
                        });
                    } 
                   
                }
            }
        } catch (error) {
            console.error("Ошибка при разборе штрихкода:", error);
        }
    };

    parseBarcode();
    return () => { isActive = false; };

}, [props.scanData]);

    useEffect(() => {
        if (props.itemLot) {
            goodsDP.getById(props.itemLot.goods.idGlobal, (e) => {
                setIsGnvls(e.gnvls.important ?? false);
            });
        }
    }, []);

    useEffect(() => {
        calculated(
            {
                quantity: data.quantityFrom,
                supplierPriceExcludingVat: props.itemLot.supplierCostInfo.price ?? 0,
                supplierVatRatePercentage: props.itemLot.supplierCostInfo.vat ?? 0,
                supplierPriceWithVat: props.itemLot.supplierCostInfo.priceIncVat ?? 0,
                supplierAmountExcludingVat: props.itemLot.supplierCostInfo.sum ?? 0,
                supplierVatAmount: props.itemLot.supplierCostInfo.vatSum ?? 0,
                supplierAmountWithVat: props.itemLot.supplierCostInfo.sumIncVat ?? 0,
                retailUnitMargin: props.itemLot.productMargin ?? 0,
                retailPrice: props.itemLot.retailCostInfo.price ?? 0,
                retailPriceWithVat: props.itemLot.retailCostInfo.priceIncVat ?? 0,
                percentageOfVatRateRetail: props.itemLot.retailCostInfo.vat ?? 0,
                retailAmount: props.itemLot.retailCostInfo.sum ?? 0,
                retailAmountWithVat: props.itemLot.retailCostInfo.sumIncVat ?? 0,
                numerator: scalingRatioTo?.scalingRatioToNumerator ?? 1,
                denominator: scalingRatioTo?.scalingRatioToDenominator ?? 1,
                eventType: "DenominatorChanged",
                percentageOfMarkupRetail: props.itemLot.retailCostInfo.adprice ?? 0,
                supplierMarkupPercentage: props.itemLot.supplierCostInfo.adprice ?? 0,
                supplierVatPerUnit: props.itemLot.supplierCostInfo.vatPrice ?? 0,
                retailVatPerUnit: props.itemLot.retailCostInfo.vatPrice ?? 0,
                vatAmountRetail: props.itemLot.retailCostInfo.vatSum ?? 0,
                manufacturerPrice: props.itemLot.producerPrice ?? 0
            } as IPricingDocumentItemDTO,
            scalingRatioTo?.scalingRatioEntityTo.idGlobal
        );
    }, [scalingRatioTo]);

    useEffect(() => {
        if (calculate) {
            calculated(
                {
                    quantity: data.quantityFrom,
                    supplierPriceExcludingVat: props.itemLot.supplierCostInfo?.price ?? 0,
                    supplierVatRatePercentage: props.itemLot.supplierCostInfo.vat ?? 0,
                    supplierPriceWithVat: props.itemLot.supplierCostInfo.priceIncVat ?? 0,
                    supplierAmountExcludingVat: props.itemLot.supplierCostInfo.sum ?? 0,
                    supplierVatAmount: props.itemLot.supplierCostInfo.vatSum ?? 0,
                    supplierAmountWithVat: props.itemLot.supplierCostInfo.sumIncVat ?? 0,
                    retailUnitMargin: props.itemLot.productMargin ?? 0,
                    retailPrice: props.itemLot.retailCostInfo?.price ?? 0,
                    retailPriceWithVat: props.itemLot.retailCostInfo.priceIncVat ?? 0,
                    percentageOfVatRateRetail: props.itemLot.retailCostInfo.vat ?? 0,
                    retailAmount: props.itemLot.retailCostInfo.sum ?? 0,
                    retailAmountWithVat: props.itemLot.retailCostInfo.sumIncVat ?? 0,
                    numerator: scalingRatioTo?.scalingRatioToNumerator ?? 1,
                    denominator: scalingRatioTo?.scalingRatioToDenominator ?? 1,
                    eventType: "QuantityСhanged",
                    percentageOfMarkupRetail: props.itemLot.retailCostInfo.adprice ?? 0,
                    supplierMarkupPercentage: props.itemLot.supplierCostInfo.adprice ?? 0,
                    supplierVatPerUnit: props.itemLot.supplierCostInfo.vatPrice ?? 0,
                    retailVatPerUnit: props.itemLot.retailCostInfo.vatPrice ?? 0,
                    vatAmountRetail: props.itemLot.retailCostInfo.vatSum ?? 0,
                    manufacturerPrice: props.itemLot.producerPrice ?? 0
                } as IPricingDocumentItemDTO,
                scalingRatioTo?.scalingRatioEntityTo?.idGlobal
            );
            setCalculate(false);
        }
    }, [calculate]);

    const { t } = useTranslation();
    const errorsT = (value: string) => t("errors." + value);
    const baseT = (value: string) => t("modals.actDisassemblingUpdateItem." + value);
    
    const { isValid, errors, setErrors } = useForm<IValidator>({
        validations: {
            quantity: {
                required: {
                    value: data.quantityFrom > item.quantityRem + item.quantityRes || data.quantity === 0 ? true : false,
                    message: `${baseT("errors.moreThan")} ${data.quantityFrom} ${baseT("errors.lessThan")} 1`,
                },
            },
            scalingRatioTo: {
                required: {
                    value: scalingRatioTo?.scalingRatioEntityTo?.displayName ? false : true,
                    message: errorsT("required"),
                },
            },
        },
    });

    const calculated = (calcItem: IPricingDocumentItemDTO, idScalingRatio?: string) => {
        pricingDP.CalculateItem(props.pricingModel.idGlobal, calcItem, (e) => {
            let priceGnvls = GetGnvlsPrice(calcItem);
            setData({
                ...data,
                retailCostInfo: {
                    adprice: e.percentageOfMarkupRetail,
                    vatPrice: e.retailVatPerUnit,
                    vat: e.percentageOfVatRateRetail,
                    vatSum: e.vatAmountRetail as number,
                    sumIncVat: e.retailAmountWithVat,
                    sum: e.retailAmount as number,
                    price: e.retailPrice,
                    priceIncVat: !isGnvls ? e.retailPriceWithVat : priceGnvls,
                },
                supplierCostInfo: {
                    adprice: e.percentageOfMarkupRetail,
                    vatPrice: e.retailVatPerUnit,
                    vat: e.supplierVatRatePercentage,
                    vatSum: e.supplierVatAmount,
                    sumIncVat: e.supplierAmountWithVat,
                    sum: e.supplierAmountExcludingVat,
                    price: e.supplierPriceExcludingVat,
                    priceIncVat: e.supplierPriceWithVat,
                },
                productMargin: e.retailUnitMargin,
                quantityFrom: calcItem.quantity,
                quantity: e.quantity * e.denominator,
                idScalingRatioToGlobal: idScalingRatio ?? data.idScalingRatioToGlobal,
                producerPrice: e.manufacturerPrice
            });
            setIsCalculated(true);
        });
    };

    const returnCreateItem = (): ICreateItem => {
        return {
            item: { ...data, 
                // объединяем старые и новые КИЗы
                kizs: [...(data.kizs || []), ...kizData.kizs], 
                kizOsuDtos: [...(data.kizOsuDtos || []), ...kizData.kizOsuDtos],
                kizBoxes: [...(data.kizBoxes || []), ...kizData.kizBoxes], dateCreated: DateTime.now() 
            },
            displayItem: {
                idGlobal: data.idGlobal,
                idLotFromGlobal: data.idLotFromGlobal,
                goodsName: item.goods?.displayName,
                quantity: data.quantity,
                quantityFrom: data.quantityFrom,
                scalingRatioFrom: item.scalingRatio.displayName,
                goodsCode: item.goodsCode,
                producer: item.producer.displayName,
                scalingRatioTo: scalingRatioTo?.scalingRatioEntityTo?.displayName ?? "",
                supplierPrice: data.supplierCostInfo.price,
                retailPrice: data.retailCostInfo.price,
                retailSumWithVat: props.itemLot?.retailCostInfo?.priceIncVat * data.quantityFrom,
                retailPriceIncVat: data.retailCostInfo.priceIncVat ?? 1,
                supplierSum: data.supplierCostInfo.price * data.quantityFrom,
                isGnvls: isGnvls,
                isKiz: data.isKiz ?? false,
                countKizScan: data.isKiz === false ? undefined : props.kizCount,
                dateCreated: DateTime.now()
            },
            filter: {
                quantityMax: item.quantityRem + item.quantityRes,
                quantityMin: 0,
                idItem: data.idGlobal,
            },
        };
    };

    useEffect(() => {
        if (data.idScalingRatioToGlobal?.length > 0) {
            scalingRatioDP.overrideGetById(data.idGoodsGlobal, data.idScalingRatioToGlobal, (value) => {
                setScalingRatioTo({
                    scalingRatioEntityTo: { displayName: value.displayName, idGlobal: value.idGlobal },
                    scalingRatioToNumerator: value.numerator,
                    scalingRatioToDenominator: value.denominator,
                });
            });
        }
    }, []);

    const lotRemain = useLotRemain(props.itemEdit.idLotFromGlobal, props.idDocument);

    return (
        <BaseModalWindow
            header={baseT("header")}//"Создание позиции"
            ok={{
                onClick: () => {
                    if (isCalculated && isValid()) {
                        props.ok(returnCreateItem());
                    }
                },
                title: "ОК",
            }}
            cancel={{
                onClick: () => {
                    props.cancel();
                },
                title: baseT("cancel"),
            }}
            modalWindowClassName={modalStyles.modalWindowConfirm}
            footerStyle="confirm"
        >
            <TextAreaInput label={baseT("goodsName")}/*"Товар"*/ className={styles.field_GoodsName} value={item.goods?.displayName} disabled />
            <GridWrapper cols={2}>
                <TextInput label={baseT("lotName")}/*"Партия"*/ disabled value={props.itemLot.docNum} />
                <TextInput label={baseT("scalingRatioFrom")}/*"Единица измерения"*/ value={item.scalingRatio?.displayName} disabled />
            </GridWrapper>
            <GridWrapper cols={3}>
                <NumberInput label={baseT("quantityToOnStore")}/*"Количество единиц на складе"*/ disabled value={lotRemain} />
                <CurrencyInput
                    required
                    label={baseT("quantityFromOnStore")}/*"Количество исходных единиц"*/
                    value={data.quantityFrom}
                    min={0}
                    max={lotRemain}
                    onChange={(value) => {
                        setIsCalculated(false);
                        calculated(
                            {
                                quantity: value,
                                supplierPriceExcludingVat: props.itemLot.supplierCostInfo.price,
                                supplierVatRatePercentage: props.itemLot.supplierCostInfo.vat,
                                supplierPriceWithVat: props.itemLot.supplierCostInfo.priceIncVat,
                                supplierAmountExcludingVat: props.itemLot.supplierCostInfo.sum,
                                supplierVatAmount: props.itemLot.supplierCostInfo.vatSum,
                                supplierAmountWithVat: props.itemLot.supplierCostInfo.sumIncVat,
                                retailUnitMargin: props.itemLot.productMargin,
                                retailPrice: props.itemLot.retailCostInfo.price,
                                retailPriceWithVat: props.itemLot.retailCostInfo.priceIncVat,
                                percentageOfVatRateRetail: props.itemLot.retailCostInfo.vat,
                                retailAmount: props.itemLot.retailCostInfo.sum,
                                retailAmountWithVat: props.itemLot.retailCostInfo.sumIncVat,
                                numerator: scalingRatioTo?.scalingRatioToNumerator ?? 1,
                                denominator: scalingRatioTo?.scalingRatioToDenominator ?? 1,
                                eventType: "QuantityСhanged",
                                percentageOfMarkupRetail: props.itemLot.retailCostInfo.adprice ?? 0,
                                supplierMarkupPercentage: props.itemLot.supplierCostInfo.adprice ?? 0,
                                supplierVatPerUnit: props.itemLot.supplierCostInfo.vatPrice ?? 0,
                                retailVatPerUnit: props.itemLot.retailCostInfo.vatPrice ?? 0,
                                vatAmountRetail: props.itemLot.retailCostInfo.vatSum ?? 0,
                                manufacturerPrice: props.itemLot.producerPrice ?? 0
                            } as IPricingDocumentItemDTO,
                            scalingRatioTo?.scalingRatioEntityTo?.idGlobal
                        );
                    }}
                    onEndChange={(value) => {
                        setIsCalculated(false);
                        calculated(
                            {
                                quantity: value,
                                supplierPriceExcludingVat: props.itemLot.supplierCostInfo.price,
                                supplierVatRatePercentage: props.itemLot.supplierCostInfo.vat,
                                supplierPriceWithVat: props.itemLot.supplierCostInfo.priceIncVat,
                                supplierAmountExcludingVat: props.itemLot.supplierCostInfo.sum,
                                supplierVatAmount: props.itemLot.supplierCostInfo.vatSum,
                                supplierAmountWithVat: props.itemLot.supplierCostInfo.sumIncVat,
                                retailUnitMargin: props.itemLot.productMargin,
                                retailPrice: props.itemLot.retailCostInfo.price,
                                retailPriceWithVat: props.itemLot.retailCostInfo.priceIncVat,
                                percentageOfVatRateRetail: props.itemLot.retailCostInfo.vat,
                                retailAmount: props.itemLot.retailCostInfo.sum,
                                retailAmountWithVat: props.itemLot.retailCostInfo.sumIncVat,
                                numerator: scalingRatioTo?.scalingRatioToNumerator ?? 1,
                                denominator: scalingRatioTo?.scalingRatioToDenominator ?? 1,
                                eventType: "QuantityСhanged",
                                percentageOfMarkupRetail: props.itemLot.retailCostInfo.adprice ?? 0,
                                supplierMarkupPercentage: props.itemLot.supplierCostInfo.adprice ?? 0,
                                supplierVatPerUnit: props.itemLot.supplierCostInfo.vatPrice ?? 0,
                                retailVatPerUnit: props.itemLot.retailCostInfo.vatPrice ?? 0,
                                vatAmountRetail: props.itemLot.retailCostInfo.vatSum ?? 0,
                                manufacturerPrice: props.itemLot.producerPrice ?? 0
                            } as IPricingDocumentItemDTO,
                            scalingRatioTo?.scalingRatioEntityTo?.idGlobal
                        );
                    }}
                    error={errors.quantity}
                    onFocus={() => setErrors({ ...errors, quantity: undefined })}
                />
                <NumberInputWithSideEffect label={baseT("priceBase")}/*"Исходная цена"*/ disabled value={data.quantityFrom > 0 ? props.itemLot?.retailCostInfo?.priceIncVat : 0} />
            </GridWrapper>
            <GridWrapper cols={3}>
                <GridSelectorInput
                    required
                    selectorModalJsx={ScalingRatioSelectorModal}
                    id={"inputAccompanyingSelectionGoods"}
                    label={baseT("scalingRatioTo")}//"Единица разукомплектации"
                    idGlobal={item.goods?.idGlobal}
                    masterIdGlobal={item.goods?.idGlobal}
                    gridFilter={CreateFilterNumerator}
                    onClear={() => {
                        setScalingRatioTo({
                            scalingRatioEntityTo: {} as IEntitySimpleDTO,
                            scalingRatioToNumerator: 1,
                            scalingRatioToDenominator: 1,
                        });
                        setData({ ...data, quantityFrom: 0 });
                    }}
                    selectedEntity={scalingRatioTo?.scalingRatioEntityTo}
                    onSelect={(value) => {
                        scalingRatioDP.overrideGetById(item.goods?.idGlobal, value.idGlobal, (e) => {
                            setScalingRatioTo({
                                scalingRatioEntityTo: value,
                                scalingRatioToNumerator: e.numerator,
                                scalingRatioToDenominator: e.denominator,
                            });
                            setIsCalculated(false);
                            setCalculate(true);
                        });
                    }}
                    error={errors.scalingRatioTo}
                    onFocus={() => setErrors({ ...errors, scalingRatioTo: undefined })}
                />
                <NumberInputWithSideEffect label={baseT("quantityAfter")}/*"Количество после разукомплектации"*/ disabled value={data.quantity} />
                <NumberInputWithSideEffect
                    label={baseT("priceAfter")}//"Цена после разукомплектации"
                    disabled={isGnvls}
                    value={data.quantityFrom > 0 ? data.retailCostInfo.priceIncVat : 0}
                    onChange={(value) => {
                        setData({
                            ...data,
                            retailCostInfo: {
                                adprice: data.retailCostInfo.adprice,
                                vatPrice: data.retailCostInfo.vatPrice,
                                vat: data.retailCostInfo.vat,
                                vatSum: data.retailCostInfo.vatSum as number,
                                sumIncVat: data.retailCostInfo.sumIncVat,
                                sum: data.retailCostInfo.sum as number,
                                price: data.retailCostInfo.price,
                                priceIncVat: value,
                            },
                        });
                    }}
                />
            </GridWrapper>
        </BaseModalWindow>
    );
};
